import { keepPreviousData, type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { teamService } from "@/lib/services";
import type { PaginatedResponse, TeamHubChatSummary } from "@/types";

type TeamConversationsParams = { page: number; pageSize: number };
type TeamConversationsKey = ["teamConversations", string, TeamConversationsParams];

export type ResponseTeamConversations = PaginatedResponse<TeamHubChatSummary>;

type TeamConversationsQueryOptions = Omit<
  UseQueryOptions<ResponseTeamConversations, Error, ResponseTeamConversations, TeamConversationsKey>,
  "queryKey" | "queryFn"
>;

export const useGetTeamConversations = (
  teamUuid: string,
  params: TeamConversationsParams,
  options?: TeamConversationsQueryOptions,
) => {
  return useQuery<ResponseTeamConversations, Error, ResponseTeamConversations, TeamConversationsKey>({
    queryKey: ["teamConversations", teamUuid, params],
    queryFn: () => teamService.listConversations(teamUuid, params),
    enabled: Boolean(teamUuid),
    placeholderData: keepPreviousData,
    ...options,
  });
};
